import { fmtDate } from "@/lib/api";
import { SCALES } from "@/components/CheckIn";
import { Empty } from "@/components/ui-bits";

const MiniTrend = ({ k, label, items, invert }) => {
  const vals = items.map((c) => c[k]);
  const pts = vals.map((v, i) => [10 + i * (276 / Math.max(vals.length - 1, 1)), 6 + (1 - (v - 1) / 4) * 48]);
  const path = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  const last = vals[vals.length - 1];
  const bad = invert ? last >= 4 : last <= 2;
  return (
    <div className="trend" data-testid={`checkin-trend-${k}`}>
      <div className="ss" style={{ display: "flex", justifyContent: "space-between" }}><span>{label}</span><b className="num" style={{ color: bad ? "var(--bad,#b42318)" : "var(--ink)" }} data-testid={`checkin-trend-${k}-last`}>{last}/5</b></div>
      <svg viewBox="0 0 296 64" style={{ width: "100%", height: 64 }}>
        {[1, 3, 5].map((g) => <line key={g} x1="10" x2="286" y1={6 + (1 - (g - 1) / 4) * 48} y2={6 + (1 - (g - 1) / 4) * 48} stroke="var(--line)" strokeDasharray="2 3" />)}
        {vals.length > 1 && <path d={path} fill="none" stroke="var(--accent,var(--ink))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />}
        {pts.map((p, i) => <circle key={i} cx={p[0]} cy={p[1]} r="3" fill="var(--accent,var(--ink))" />)}
      </svg>
    </div>
  );
};

export const CheckinTrends = ({ items, title = "Check-in trend · last 8 weeks" }) => (
  <div data-testid="checkin-trends">
    <div className="ss" style={{ margin: "12px 0 6px" }}>{title}</div>
    {!items?.length && <Empty>No check-ins yet.</Empty>}
    {items?.length > 0 && (
      <>
        <div className="grid3" style={{ gap: 10 }}>{SCALES.map(([k, label]) => <MiniTrend key={k} k={k} label={label} items={items} invert={k === "soreness"} />)}</div>
        <div className="ss" style={{ marginTop: 4 }}>{items.length} week{items.length !== 1 ? "s" : ""} · {fmtDate(items[0].weekStart)} → {fmtDate(items[items.length - 1].weekStart)}</div>
      </>
    )}
  </div>
);
